import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Managed">
                <h1>Our Exclusive Managed Cloud Services</h1>
              </div>
              <p className="main_para">
                Our cloud-managed services help your business evolve digitally
                by utilizing modern cloud computing. We eliminate your internal
                team's burden of managing hybrid multi-cloud environments to
                move you forward while saving cost, enhancing flexibility, and
                maximizing your in-house resources.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banner_content_txt">
              <p>
                Whether you want to manage your existing cloud-based
                infrastructure or you're thinking of migrating to the Cloud, our
                experienced professionals can help you find the right solutions
                for your business. We support your efforts to promote innovation
                and free up vital IT resources.
              </p>
              <ul>
                <li>Seamless operations</li>
                <li>Optimal performance</li>
                <li>24/7 monitoring</li>
                <li>Enhanced security </li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
